// extracted by mini-css-extract-plugin
export default {"content":"FormProfile_content__o8O-9","title":"FormProfile_title__d42-P","subtitle":"FormProfile_subtitle__k-olP"};